// Generate a unique session ID for this chat session
let sessionId = localStorage.getItem('terrazon_chat_session_id');
if (!sessionId) {
    sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('terrazon_chat_session_id', sessionId);
}

// Ajustar posición del chat cuando el scrollTop se mueve
window.addEventListener('scroll', function () {
    const scrollTopBtn = document.getElementById('scrollTopBtn');
    const chatButton = document.getElementById('chat-button');
    // if (scrollTopBtn && chatButton) {
    //     // const scrollTopBottom = parseInt(scrollTopBtn.style.bottom) || 20;
    //     // chatButton.style.bottom = (scrollTopBottom ) + 'px';
    // }
});

// Funcionalidad del chat y modal de privacidad
document.addEventListener('DOMContentLoaded', function () {
    const chatButton = document.getElementById('chat-button');
    const chatContainer = document.getElementById('chat-container');
    const chatModal = new bootstrap.Modal(document.getElementById('chatModal'));

    const privacyContent = document.getElementById('chat-privacy-content');
    const chatContent = document.getElementById('chat-content');
    const chatInputArea = document.getElementById('chat-input-area');

    const privacyAccept = document.getElementById('chat-privacy-accept');
    const privacyIgnore = document.getElementById('chat-privacy-ignore');
    const chatClose = document.getElementById('chat-close');
    const chatSend = document.getElementById('chat-send');

    // Mobile elements
    const privacyContentMobile = document.getElementById('chat-privacy-content-mobile');
    const chatContentMobile = document.getElementById('chat-content-mobile');
    const chatInputAreaMobile = document.getElementById('chat-input-area-mobile');
    const privacyAcceptMobile = document.getElementById('chat-privacy-accept-mobile');
    const privacyIgnoreMobile = document.getElementById('chat-privacy-ignore-mobile');
    const chatSendMobile = document.getElementById('chat-send-mobile');
    

    // Verificar si ya se aceptó la privacidad
    const privacyAccepted = localStorage.getItem('chatPrivacyAccepted');

    // Check if device is mobile/tablet
    const isMobile = window.innerWidth <= 768;

    chatButton.addEventListener('click', function () {
        if (isMobile) {
            chatModal.show();
            if (privacyAccepted) {
                showChatMobile();
            }
        } else {
            chatContainer.classList.toggle('d-flex');
            if (privacyAccepted) {
                showChat();
            }
        }
    });

    if(chatClose){
        chatClose.addEventListener('click', function () {
            chatContainer.classList.toggle('d-flex');
        });
    }

    // Desktop privacy handlers
    privacyAccept.addEventListener('click', function () {
        localStorage.setItem('chatPrivacyAccepted', 'true');
        showChat();
    });

    privacyIgnore.addEventListener('click', function () {
        chatContainer.classList.toggle('d-flex');
    });

    // Mobile privacy handlers
    privacyAcceptMobile.addEventListener('click', function () {
        localStorage.setItem('chatPrivacyAccepted', 'true');
        showChatMobile();
    });

    privacyIgnoreMobile.addEventListener('click', function () {
        chatModal.hide();
    });

    function showChat() {
        privacyContent.classList.add('d-none'); 
        if(chatContent){
            chatContent.classList.remove('d-none');
        }
        chatContent.classList.remove('d-none');
        const chatFirtsContent = document.getElementById('firts-chat-content');
        const chatInputArea = document.getElementById('chat-input-area');
        const chatMessages = document.getElementById('chat-messages');
        if(chatInputArea){
            chatInputArea.classList.remove('d-none');
        }
        if(chatFirtsContent && chatMessages.children.length === 0){
            chatFirtsContent.classList.remove('d-none')
        }
        // Focus on chat input
        const chatInput = document.getElementById('chat-input');
        if(chatInput) {
            chatInput.focus();
        }
        // Activar el evento de envío cuando se muestra el chat
        chatSend.addEventListener('click', () => sendMessage('desktop'));
        chatInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                sendMessage('desktop');
            }
        }); 
    }

    function showChatMobile() {
        privacyContentMobile.classList.add('d-none');
        if(chatContentMobile){
            chatContentMobile.classList.remove('d-none');
        }
        const chatFirtsContentMobile = document.getElementById('firts-chat-content-mobile');
        const chatMessagesMobile = document.getElementById('chat-messages-mobile');
        const chatHeaderMobile = document.getElementById('chat-header-mobile');
        const chatInputMobile = document.getElementById('chat-input-mobile');
        if(chatInputAreaMobile){
            chatInputAreaMobile.classList.remove('d-none');
        } 
        if(chatFirtsContentMobile && chatMessagesMobile.children.length === 0){
            chatFirtsContentMobile.classList.remove('d-none')
            chatHeaderMobile.classList.add('d-none');
        }
        // Focus on chat input
        if(chatInputMobile) {
            setTimeout(() => {

            console.log('focus');
                chatInputMobile.focus();
            }, 500);
        }
        // Activar el evento de envío cuando se muestra el chat
        chatSendMobile.addEventListener('click', () => sendMessage('mobile'));
        chatInputMobile.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                sendMessage('mobile');
            }
        });
       
    }

    // Si ya se aceptó la privacidad, activar el evento de envío inmediatamente
    if (privacyAccepted) {
        const chatHeaderMobile = document.getElementById('chat-header-mobile');
        if(chatHeaderMobile){
            chatHeaderMobile.classList.remove('d-none');
        }
        chatSend.addEventListener('click', () => sendMessage('desktop'));
        chatSendMobile.addEventListener('click', () => sendMessage('mobile'));
    }
});

const sendMessage = (device) => {
    const isMobile = device === 'mobile';
    const prefix = isMobile ? '-mobile' : '';
    
    const chatFirtsContent = document.getElementById(`firts-chat-content${prefix}`);
    if(chatFirtsContent){
        chatFirtsContent.classList.add('d-none');
    }
    const chatHeaderMobile = document.getElementById('chat-header-mobile');
    if(chatHeaderMobile){
        chatHeaderMobile.classList.remove('d-none');
    }
    const chatContent = document.getElementById(`chat-content${prefix}`);
    const chatMessages = document.getElementById(`chat-messages${prefix}`);
    if(chatContent){
        chatContent.style.display = 'block';
    }
    
    const chatInput = document.getElementById(`chat-input${prefix}`);
    const message = chatInput.value.trim();
    if (message) {
        // Add user message
        const userMessageElement = document.createElement('div');
        userMessageElement.classList.add('user-message', 'message');
        userMessageElement.textContent = message;
        chatMessages.appendChild(userMessageElement);

        // Clear input
        chatInput.value = '';

        // Scroll to bottom
        if (isMobile) {
            const chatContentMobile = document.getElementById('chat-content-mobile');
            if (chatContentMobile) {
                chatContentMobile.scrollTop = chatContentMobile.scrollHeight;
            }
        } else {
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }

        // Show loading indicator
        const loadingElement = document.createElement('div');
        loadingElement.classList.add('bot-message', 'message');
        const loadingDots = document.createElement('div');
        loadingDots.classList.add('loading-dots');
        loadingDots.innerHTML = '<span></span><span></span><span></span>';
        loadingElement.appendChild(loadingDots);
        chatMessages.appendChild(loadingElement);
        
        // Scroll to bottom when showing loading indicator
        if (isMobile) {
            const chatContentMobile = document.getElementById('chat-content-mobile');
            if (chatContentMobile) {
                chatContentMobile.scrollTop = chatContentMobile.scrollHeight;
            }
        } else {
            chatMessages.scrollTop = chatMessages.scrollHeight;
        }

        // Send message to webhook with session ID
        fetch('https://primary-production-6e7a.up.railway.app/webhook/00ce0f89-ac67-4db3-8b32-e0b5bb40326e', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                message,
                sessionId
            })
        })
            .then(response => response.json())
            .then(data => {
                // Remove loading indicator
                chatMessages.removeChild(loadingElement);

                // Add bot response
                const botMessageElement = document.createElement('div');
                botMessageElement.classList.add('bot-message', 'message');

                // The backend returns data with an 'output' field
                let responseText = "Gracias por tu mensaje. Nuestro asistente está procesando tu consulta. ¿Te gustaría agendar una llamada con uno de nuestros asesores para obtener información personalizada?";

                if (data && typeof data === 'object') {
                    if (data.output) {
                        responseText = data.output;
                    } else if (data.response) {
                        responseText = data.response;
                    }
                }

                // Usar marked.js para convertir markdown a HTML
                botMessageElement.innerHTML = marked.parse(responseText);

                chatMessages.appendChild(botMessageElement);

                // Scroll to bottom
                if (isMobile) {
                    const chatContentMobile = document.getElementById('chat-content-mobile');
                    if (chatContentMobile) {
                        chatContentMobile.scrollTop = chatContentMobile.scrollHeight;
                    }
                } else {
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
            })
            .catch(error => {
                // Remove loading indicator
                chatMessages.removeChild(loadingElement);

                // Show error message
                const botMessageElement = document.createElement('div');
                botMessageElement.classList.add('bot-message', 'message');
                const errorMessage = "En este momento estoy enfocado en ayudarte a encontrar la propiedad ideal. ¿Te gustaría agendar una llamada con uno de nuestros asesores especializados? Ellos podrán brindarte información detallada sobre las opciones que se ajusten a tus preferencias.";
                botMessageElement.innerHTML = marked.parse(errorMessage);
                chatMessages.appendChild(botMessageElement);

                // Scroll to bottom
                if (isMobile) {
                    const chatContentMobile = document.getElementById('chat-content-mobile');
                    if (chatContentMobile) {
                        chatContentMobile.scrollTop = chatContentMobile.scrollHeight;
                    }
                } else {
                    chatMessages.scrollTop = chatMessages.scrollHeight;
                }
            });
    }
};

